// import microimage from "../../../../Assets/images/2.jpg";
// import tableimage from "../../../../Assets/images/3.jpg";
// import gunimage from "../../../../Assets/images/4.jpg";
// import bikeimage from "../../../../Assets/images/5.jpg";
// import clothimage from "../../../../Assets/images/1.jpg";

import microimage from "../Assets/images/2.jpg";
import tableimage from "../Assets/images/3.jpg";
import gunimage from "../Assets/images/4.jpg";
import clothimage from "../Assets/images/1.jpg";



const Category = [
  {
    name: "Product1",
    image: clothimage,
    subcategories: [
      "Performers",
      "Photography",
      "Decoration",
      "Photography",
      "Decoration",
    ],
  },
  {
    name: "Product2",
    image: microimage,
    subcategories: [
      "Performers",
      "Photography",
      "Decoration",
      "Photography",
      "Decoration",
    ],
  },
  {
    name: "Product3",
    image: tableimage,
    subcategories: [
      "Performers",
      "Photography",
      "Decoration",
      "Photography",
      "Decoration",
    ],
  },
  {
    name: "Product4",
    image: gunimage,
    subcategories: [
      "Performers",
      "Photography",
      "Decoration",
      "Photography",
      "Decoration",
    ],
  },

  {
    name: "Product5",
    image: clothimage,
    subcategories: ["Performers", "Photography", "Decoration"],
  },

  {
    name: "Product6",
    image: tableimage,
    subcategories: ["Performers", "Photography", "Decoration"],
  },
  {
    name: "Product7",
    image: clothimage,
    subcategories: ["Performers", "Photography", "Decoration"],
  },

  {
    name: "Product8",
    image: tableimage,
    subcategories: ["Performers", "Photography", "Decoration"],
  },
  {
    name: "Product9",
    image: clothimage,
    subcategories: ["Performers", "Photography", "Decoration"],
  },
  {
    name: "Product10",
    image: tableimage,
    subcategories: ["Performers", "Photography", "Decoration"],
  },

  {
    name: "Product11",
    image: tableimage,
    subcategories: ["Performers", "Photography", "Decoration"],
  },
  {
    name: "Product12",
    image: gunimage,
    subcategories: [
      "Performers",
      "Photography",
      "Decoration",
      "Photography",
      "Decoration",
    ],
  },

 
];

export default Category